module.exports = __webpack_public_path__ + "static/media/wat_logo.9d363ed3.png";